module.exports = __webpack_public_path__ + "static/img/11.949494a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/11.png
// module id = ovPP
// module chunks = 4